export default __webpack_public_path__ + "../staticImages/co2-neutral-inverse.svg";